import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel'];

  /**
   * Select a tab and show its associated panel.
   *
   * @param {{ currentTarget: HTMLElement }} event
   */
  select({ currentTarget }) {
    this.tabTargets.forEach((tab) => {
      const selected = tab === currentTarget;
      tab.setAttribute('aria-selected', selected);
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });
    this.panelTargets.forEach((panel) => {
      panel.toggleAttribute('hidden', panel.id !== currentTarget.getAttribute('aria-controls'));
    });
  }

  /**
   * Focus and select a tab using the arrow, Home, or End keys.
   *
   * @param {KeyboardEvent} event
   */
  navigate(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    const indices = {
      ArrowLeft: (index + this.tabTargets.length - 1) % this.tabTargets.length,
      ArrowRight: (index + 1) % this.tabTargets.length,
      Home: 0,
      End: this.tabTargets.length - 1,
    };
    if (event.key in indices) {
      event.preventDefault();
      const tab = this.tabTargets[indices[event.key]];
      tab.focus();
      this.select({ currentTarget: tab });
    }
  }
}
